/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useContext } from "react";

import { bem } from "../../../shared/BEM";
import { useFormElement } from "../../../shared/hooks/useFormElement";
import { FormFieldLabel } from "../../../shared/FormModel/elements/FormFieldLabel";
import { applyInlineElementMods } from "./shared";
import { ConfigContext } from "../../ConfigContext";

/**
 * Component props
 */
export interface IFormFieldLabelComponentProps {
	element: FormFieldLabel,
}

/**
 * Form field wrapper
 * @param props Component props
 */
export function FormFieldLabelComponent(props: IFormFieldLabelComponentProps) {

	const configCtx = useContext(ConfigContext);
	const state = useFormElement(props.element);

	// Dont'r render if row-actions for print
	if (configCtx.mode === "ssr" && state.config.width === "row-actions") {
		return null;
	}

	const stlMods = [
		"type-label",
		"style-" + (state.config.style || "default"),
		"v-align-" + (state.config.verticalAlign || "top")
	];

	const labelMods = [
		"align-" + (state.config.labelAlign || "left")
	];

	const valueMods = [
		"align-" + (state.config.align || "left")
	];

	applyInlineElementMods(state.config, stlMods);

	const stl = bem("form-field", "", stlMods);

	return <label className={stl.str}>
		{ state.labelValue ?
		<span className={stl.el("label").mod(labelMods).str}>
			<span className={stl.el("label-contents").str}>{state.labelValue}</span>
		</span>
		: null }
		{ state.value ?
		<span className={stl.el("field").str}>
			<span className={stl.el("input-text-value").mod(valueMods).str}>{state.value}</span>
			{state.config.suffix ?
				<span className={stl.el("input-suffix").str}>{state.config.suffix}</span>
			: null }
		</span>
		: null }
	</label>;

}